<script setup>
import { computed } from 'vue';
import ConfigForm from '../components/ConfigForm.vue';
import DocumentUpload from '../components/DocumentUpload.vue';
import DocumentTable from '../components/DocumentTable.vue';
import KbSearchPreview from '../components/KbSearchPreview.vue';
import StudioSection from '../components/StudioSection.vue';
import { useI18n } from 'vue-i18n';

defineProps({
  bot: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();

// Numeric retrieval tuning lives in a collapsed card; the switches stay visible.
// Built lazily: the account locale may load after this tab is set up.
const sections = computed(() =>[
    {
      key: 'ADVANCED',
      title: t('AI_AGENT.STUDIO.ADVANCED'),
      description: t('AI_AGENT.STUDIO.ADVANCED_HELP'),
      icon: 'i-lucide-sliders-horizontal',
      collapsible: true,
    },
  ]
);

const fields = [
  {
    path: 'rag.enabled',
    label: 'AI_AGENT.KNOWLEDGE.FIELDS.ENABLED',
    type: 'switch',
    help: 'AI_AGENT.KNOWLEDGE.FIELDS.ENABLED_HELP',
  },
  {
    path: 'rag.top_k',
    label: 'AI_AGENT.KNOWLEDGE.FIELDS.TOP_K',
    type: 'number',
    help: 'AI_AGENT.KNOWLEDGE.FIELDS.TOP_K_HELP',
    section: 'ADVANCED',
  },
  {
    path: 'rag.retry_top_k',
    label: 'AI_AGENT.KNOWLEDGE.FIELDS.RETRY_TOP_K',
    type: 'number',
    help: 'AI_AGENT.KNOWLEDGE.FIELDS.RETRY_TOP_K_HELP',
    section: 'ADVANCED',
  },
  {
    path: 'rag.min_score',
    label: 'AI_AGENT.KNOWLEDGE.FIELDS.MIN_SCORE',
    type: 'number',
    help: 'AI_AGENT.KNOWLEDGE.FIELDS.MIN_SCORE_HELP',
    section: 'ADVANCED',
  },
  {
    path: 'rag.answer_only_from_kb',
    label: 'AI_AGENT.KNOWLEDGE.FIELDS.ANSWER_ONLY_FROM_KB',
    type: 'switch',
    help: 'AI_AGENT.KNOWLEDGE.FIELDS.ANSWER_ONLY_FROM_KB_HELP',
  },
  {
    path: 'rag.include_help_center',
    label: 'AI_AGENT.KNOWLEDGE.FIELDS.INCLUDE_HELP_CENTER',
    type: 'switch',
    help: 'AI_AGENT.KNOWLEDGE.FIELDS.INCLUDE_HELP_CENTER_HELP',
  },
];
</script>

<template>
  <div class="flex flex-col gap-5">
    <StudioSection
      :title="$t('AI_AGENT.KNOWLEDGE.DOCUMENTS_HEADING')"
      :description="$t('AI_AGENT.KNOWLEDGE.DOCUMENTS_HELP')"
      icon="i-lucide-files"
    >
      <DocumentUpload :bot="bot" />
      <DocumentTable :bot="bot" />
    </StudioSection>

    <StudioSection
      :title="$t('AI_AGENT.KNOWLEDGE.SEARCH.HEADING')"
      :description="$t('AI_AGENT.KNOWLEDGE.SEARCH.HELP')"
      icon="i-lucide-search"
    >
      <KbSearchPreview :bot="bot" />
    </StudioSection>

    <ConfigForm
      :bot="bot"
      :fields="fields"
      :sections="sections"
      :title="$t('AI_AGENT.KNOWLEDGE.SETTINGS_HEADING')"
      :description="$t('AI_AGENT.KNOWLEDGE.SETTINGS_HELP')"
      icon="i-lucide-settings-2"
    />
  </div>
</template>
